import { render, staticRenderFns } from "./PromotionLineItemGrid.vue?vue&type=template&id=fb511ac8&"
import script from "./PromotionLineItemGrid.vue?vue&type=script&lang=ts&"
export * from "./PromotionLineItemGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports